export const NAV_ROUTES = {
  DASHBOARD: "/",
  DATA_PAGE: "/shippers/data",
  SHIPMENT_TRACKING: "/shippers/data/shipment-tracking",
  NETWORK: "/network",
  SUPPLIER_NETWORK: "/supplier-network",
  CHAT: "/chat",
  ACCOUNT: "/account",
  companyBranches: (companyId: number) => `/companies/${companyId}/branches`,
  companyAdmin: (companyId: number) => `/companies/${companyId}`,
  companyProfile: (companyId: number) => `/companies/${companyId}/profile`,
} as const;

export function isRouteActive(
  pathname: string,
  route: string,
  exactMatch = false,
): boolean {
  if (exactMatch) return pathname === route;
  return pathname === route || pathname.startsWith(`${route}/`);
}

export function isCompanyRouteActive(
  pathname: string,
  routeType: "branches" | "admin" | "profile",
): boolean {
  const companyMatch = /^\/companies\/\d+/.exec(pathname);
  if (!companyMatch) return false;

  if (routeType === "admin")
    return /^\/companies\/\d+$/.exec(pathname) !== null;
  if (routeType === "branches") return pathname.includes("/branches");
  if (routeType === "profile") return pathname.includes("/profile");
  return false;
}
